import { Link } from 'react-router-dom';

import ColumnFilterSort from '../../components/tableServerSide/ColumnFilterSort';

import { formatDateTimestamp } from '../../util/date';

import { escapeSpecialCharsInFilterInput } from '../util';

export const columnSortModifiersCatalogTypesList = {
  name: null,
  salesOrg: null,
  createTimestamp: null,
  createdBy: null,
  defaultSort: { createTimestamp: 'desc' }
};

export const columnFilterModifiersCatalogTypesList = {
  name: { expression: 'Like', value: escapeSpecialCharsInFilterInput },
  salesOrg: { expression: 'Like' },
  createTimestamp: { value: value => value && Date.parse(value) && new Date(value).toISOString() },
  createdBy: { expression: 'Like' }
};

export const getCatalogTypesListColumns = () => {
  return [
    {
      Header: tableInstance => <ColumnFilterSort header='Name' tableInstance={tableInstance} />,
      width: 250,
      accessor: 'name',
      // eslint-disable-next-line react/prop-types
      Cell: ({ row, value }) => (
        // eslint-disable-next-line react/prop-types
        <Link to={`/catalogTypes/edit/${row.original.id}`} className='catalogs__link'>
          {value}
        </Link>
      )
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Sales Org' tableInstance={tableInstance} />,
      accessor: 'salesOrg',
      id: 'salesOrg'
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Created' tableInstance={tableInstance} />,
      accessor: 'createTimestamp',
      Cell: ({ value }) => formatDateTimestamp(value)
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Created By' tableInstance={tableInstance} />,
      accessor: 'createdBy',
      Cell: ({ value }) => value?.split('@')[0]
    }
  ];
};
